import { images } from './images';

export type ProductFormat = {
  label: string;
  image: string;
};

export type Product = {
  id: string;
  name: string;
  tagline: string;
  aloePercent: number;
  benefits: string[];
  formats: ProductFormat[];
};

export const newProducts: Product[] = [
  {
    id: 'creme-reparatrice',
    name: 'Crème Réparatrice',
    tagline: 'Adaptée à tous les types de peaux, pour hydrater en profondeur.',
    aloePercent: 75,
    benefits: ['Certifiée Bio et 75% d’Aloe Vera', 'Visage – corps – mains', 'Format familial'],
    formats: [{ label: 'Tube 150 ml', image: images.creme150 }],
  },
  {
    id: 'gel-97',
    name: 'Gel 97% Aloe Vera',
    tagline: 'Adapté à tous les types de peaux, pour apaiser et soulager.',
    aloePercent: 97,
    benefits: [
      'Certifié Bio avec 97% d’Aloe Vera',
      'Corps – visage – cheveux',
      'En 2 contenants différents pour faciliter les usages',
    ],
    formats: [
      { label: 'Flacon pompe 250 ml', image: images.gel250 },
      { label: 'Tube 100 ml', image: images.gel100 },
    ],
  },
];
